import { api } from './api';
import { DocumentRelationship, CreateDocumentRelationshipRequest, RelationshipSearchResult } from '../types/documents';

class DocumentRelationshipService {
  async getByDocumentId(documentId: string): Promise<DocumentRelationship[]> {
    const response = await api.get(`/document-relationships/by-document/${documentId}`);
    return response.data;
  }

  async create(data: CreateDocumentRelationshipRequest): Promise<DocumentRelationship> {
    const response = await api.post('/document-relationships', data);
    return response.data;
  }

  async remove(id: string): Promise<void> {
    await api.delete(`/document-relationships/${id}`);
  }

  async searchDocuments(documentId: string, query: string): Promise<RelationshipSearchResult[]> {
    const response = await api.get('/document-relationships/search', {
      params: { documentId, q: query },
    });
    return response.data;
  }
}

export const documentRelationshipService = new DocumentRelationshipService();
